<template>
    <v-row class="ma-0 pa-0">
        <v-col md="2" sm="12" cols="12">
            <Sidebar></Sidebar>
        </v-col>
        <v-col md="10" sm="12" cols="12">
            <h1 class="headline">Historical Listing</h1>
            <v-divider></v-divider>
            <p>
                The historical listing contains both territorial and statehood legislators. Legislators who served the Dakota Territory from 1861-1889, are listed as “territorial.” South Dakota became a state on November 2, 1889.  Legislators who served South Dakota from 1890-present, are listed as “statehood.”
            </p>
            <br />
            <p>
                Total Legislators <v-chip>{{filteredMembers.length}}</v-chip>
            </p>
            <br />
            <v-text-field label="Search"
                          clearable
                          v-model="search">
                <template v-slot:append>
                    <v-icon>{{searchIcon}}</v-icon>
                </template>
            </v-text-field>
            <FilterableDataTable :headers="headers"
                                 :items="filteredMembers"
                                 item-key="MemberServiceId"
                                 multi-sort
                                 :items-per-page="50"
                                 :sort-by="['Name']"
                                 :sort-desc="[false]"
                                 :editHeaders="true"
                                 :loading="loading"
                                 :search="search"
                                 loading-text="Loading... Please wait"
                                 class="elevation-1"
                                 style="table-layout: fixed;">
                <template v-slot:item.Name="{ item }">
                    <router-link :to="'/Historical/Legislator/Profile/' + item.MemberId"><span style="white-space: nowrap;">{{ item.Name }}</span></router-link>
                </template>
                <template v-slot:item.Body="{item}">
                    <span class="text-xs-center" v-if="item.Body" v-html="item.Body.join(',&nbsp;')"></span>
                </template>
            </FilterableDataTable>
        </v-col>
    </v-row>
</template>
<script>
    import { mdiMagnify } from '@mdi/js';
    const Sidebar = () => import("@/Menus/Sidebar.vue");
    const FilterableDataTable = () => import("@/Components/FilterableDataTable.vue");

    export default {
        name: 'Historical',
        components: {
            FilterableDataTable, Sidebar
        },
        methods: {
            LoadData()
            {
                this.loading = true;
                fetch('/api/Historical/AllFlatMembers',
                    {
                        method: "GET",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" },
                    })
                    .then(res =>
                    {
                        if (res.ok)
                            return res.json();
                        else
                            return res.text().then(r => Promise.reject(r));
                    })
                    .then(response =>
                    {
                        response = EncodeDatetimes(response);

                        response = response.map(x =>
                        {
                            x.Name = (x.LastName || '') + ', ' + (x.FirstName || '') + ' ' + (x.MiddleName || '');

                            if (x.Remarks != null && x.Remarks.length > 110)
                                x.SmallRemarks = x.Remarks.substring(0, 110);
                            else
                                x.SmallRemarks = x.Remarks;

                            return x;
                        });

                        this.filteredMembers = response;
                        this.loading = false;
                    })
                    .catch(error =>
                    {
                        throw new Error(error);
                    });
            },
        },
        data: function ()
        {
            return {
                searchIcon: mdiMagnify,
                search: '',
                loading: false,
                headers: [
                    {
                        text: 'Name',
                        value: 'Name',
                        align: 'left',
                        width: '20ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Gender',
                        value: 'Gender',
                        align: 'left',
                        width: '15ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'FirstName',
                        value: 'FirstName',
                        align: 'left',
                        width: '15ch',
                        sortable: true,
                        visible: false,
                        filterable: true,
                    },
                    {
                        text: 'LastName',
                        value: 'LastName',
                        align: 'left',
                        width: '15ch',
                        sortable: true,
                        visible: false,
                        filterable: true,
                    },
                    {
                        text: 'MiddleName',
                        value: 'MiddleName',
                        align: 'left',
                        width: '10ch',
                        sortable: true,
                        visible: false,
                        filterable: true,
                    },
                    {
                        text: 'Birth',
                        value: 'Birthdate',
                        align: 'left',
                        width: '18ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Death',
                        value: 'Deathdate',
                        align: 'left',
                        width: '18ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Type',
                        value: 'MemberType',
                        align: 'left',
                        width: '13ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Remarks',
                        value: 'Remarks',
                        align: 'left',
                        width: '30ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Office',
                        value: 'Office',
                        align: 'left',
                        width: '15ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Party',
                        value: 'Party',
                        align: 'left',
                        width: '20ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Body',
                        value: 'Body',
                        align: 'left',
                        width: '20ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'City',
                        value: 'City',
                        align: 'left',
                        width: '20ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'County',
                        value: 'County',
                        align: 'left',
                        width: '20ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'Start Year',
                        value: 'StartYear',
                        align: 'left',
                        width: '10ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                    {
                        text: 'End Year',
                        value: 'EndYear',
                        align: 'left',
                        width: '10ch',
                        sortable: true,
                        visible: true,
                        filterable: true,
                    },
                ],
                filteredMembers: [],
            }
        },
        mounted: function ()
        {
            this.LoadData();
        },
        watch: {
        },
        computed: {
            Title: function ()
            {
                let title = 'Historical Legislators';
                return title;
            },
            Description: function ()
            {
                return this.Title;
            }
        },
        metaInfo()
        {
            return {
                title: this.Title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.Description },
                    // OpenGraph data (Most widely used)
                    { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                    // The list of types is available here: http://ogp.me/#types
                    { vmid: 'og:type', property: 'og:type', content: 'website' },
                    // Should be the same as your canonical link, see below.
                    { vmid: 'og:url', property: 'og:url', content: window.location.href },
                    // Often the same as your meta description, but not always.
                    { vmid: 'og:description', property: 'og:description', content: this.Description },

                    // Twitter card
                    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                    { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                    { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                    { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                ],
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0] }
                ]
            }
        }
    };
</script>
<style></style>